import moment from "moment";
import { Link } from "react-router-dom";
import EndPoints from "src/Constants/EndPoints";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import { useTranslation } from "react-i18next";


function NotificationItem({ data: noty, refetch }: any) {
  const { t, i18n } = useTranslation();
  const { id, notification, isRead, data: { payload, type } } = noty;
  const { groupId, id: postId } = JSON.parse(payload);
  const toLink = groupId && postId ? "/groups/" + groupId + "/" + postId : (groupId ? "/groups/" + groupId : "/home/" + postId);

  const [readNotification] = useApiMutation({
    onSettled: () => {
      refetch();
    },
  });

  const handleReadNotification = async () => {
    try {
      await readNotification({
        url: EndPoints.readNotification,
        method: 'PUT',
        data: {
          id: id,
        },
      });
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <Link to={toLink}>
      <div className="d-flex py-2 justify-content-between align-items-center notification_separate px-2">
        <div className={`mx-2 notification_data cursor-pointer ${i18n.dir()==='rtl'?'text-right':''}`} onClick={() => handleReadNotification()}>
          <p className="mb-0 fz14">
            {`${notification.body} ${t(type)}`} 
          </p>
          <p className="mb-0">
            <span className="fz12 text-primary">{id ? moment(new Date(id)).fromNow() : ""}</span>
          </p>
        </div>
        <div className="unread_circle text-right">
          {
            isRead ? "" : <i
              className="fa fa-circle text-primary fz12"
              aria-hidden="true"
            ></i>
          }
        </div>
      </div >
    </Link>
  )
}

export default NotificationItem